<ng-container *ngIf="loading$ | async; else accountMapper">
  <p class="text-center w-full py-16"><em>Accounts are loading</em></p>
</ng-container>
<ng-template #accountMapper>
  <div
    class="flex flex-col items-stretch justify-start py-4 space-y-2 text-center"
    *ngIf="form"
    [formGroup]="form"
  >
    <ng-container *ngIf="accountsToMap$ | async as accountsToMap">
      <ng-container *ngIf="accountsToMap.revenue.length">
        <h2>Revenue Accounts</h2>
        <div
          class="flex flex-row justify-stretch"
          *ngFor="let account of accountsToMap.revenue"
        >
          <account-mapping-field
            [key]="account"
            type="revenue"
            class="w-full"
            [formControlName]="account"
          ></account-mapping-field>
        </div>
      </ng-container>
      <ng-container *ngIf="accountsToMap.expenses.length">
        <h2>Expense Accounts</h2>
        <div
          class="flex flex-row justify-stretch"
          *ngFor="let account of accountsToMap.expenses"
        >
          <account-mapping-field
            class="w-full"
            [key]="account"
            type="expense"
            [formControlName]="account"
          ></account-mapping-field>
        </div>
      </ng-container>
      <ng-container *ngIf="accountsToMap.payment.length">
        <h2>Payment Accounts</h2>
        <div
          class="flex flex-row justify-stretch"
          *ngFor="let account of accountsToMap.payment"
        >
          <account-mapping-field
            class="w-full"
            [key]="account"
            type="payment"
            [formControlName]="account"
          ></account-mapping-field>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
